import { useParams, useSearchParams } from 'react-router-dom';

import { useLookupTftQuery } from '@/services/qriotsApi';
import type { Platform } from '@/types/qriots';
import { classifyQriotsError } from '@/services/qriotsErrors';
import { Loader } from '@/components/common/Loader';
import { TftProfileCard } from '@/components/riot/TftProfileCard';
import { QriotsErrorState } from '@/components/riot/QriotsErrorState';
import { SaveAccountButton } from '@/components/riot/SaveAccountButton';

export function RiotTftDetail() {
  const { puuid = '' } = useParams<{ puuid: string }>();
  const [search] = useSearchParams();
  const region = (search.get('region') ?? 'EUW1') as Platform;
  const gameName = search.get('gameName') ?? '';
  const tagLine = search.get('tagLine') ?? '';

  const profile = useLookupTftQuery(
    { gameName, tagLine, region },
    { skip: !gameName || !tagLine },
  );

  if (profile.isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (profile.error) {
    const { kind, retryAfterSec } = classifyQriotsError(profile.error);
    return (
      <QriotsErrorState
        kind={kind}
        retryAfterSec={retryAfterSec}
        onRetry={profile.refetch}
      />
    );
  }

  if (!profile.data) return null;

  return (
    <div className="flex flex-col gap-4 pb-6 pt-4">
      <TftProfileCard data={profile.data} />
      {puuid && gameName && tagLine && (
        <SaveAccountButton
          puuid={puuid}
          game="tft"
          region={region}
          gameName={gameName}
          tagLine={tagLine}
        />
      )}
    </div>
  );
}
